<template>
  <b-alert v-if="errors.any() && $lodash.size(lines) > 0" :variant="variant" show>
    <div v-if="compact">
      <div v-if="$lodash.size(lines) > 1">
        There are validation errors in the following tabs:

        <ul class="mb-0">
          <li v-for="(error, index) in lines" :key="`validation-error-${index}`">
            {{ error[0] }}
          </li>
        </ul>
      </div>
      <div v-else>
        Please attend to the validation error in the
        <b-badge variant="warning">
          <span v-for="(error, index) in lines" :key="`validation-error-${index}`">{{
            error[0]
          }}</span>
        </b-badge>
        tab
      </div>
    </div>

    <div v-else>
      <ul class="mb-0">
        <li v-for="(error, index) in lines" :key="`validation-error-${index}`">
          {{ error[0] }}
        </li>
      </ul>
    </div>
  </b-alert>
</template>

<script type="text/babel">
export default {
  props: {
    variant: {
      type: String,
      required: false,
      default: "warning",
    },
    errors: {
      type: Object,
      required: true,
    },
    compact: {
      type: Boolean,
      required: false,
      default: true,
    },
    excludedSection: {
      type: String,
      required: false,
      default: "",
    },
  },

  data() {
    return {
      initialised: false,
    };
  },

  computed: {
    lines() {
      if (this.compact) {
        return this.errors.compact(this.excludedSection);
      }

      return this.errors.all();
    },
  },

  mounted() {},
};
</script>
